interface ErrorBannerProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorBanner({ title = "Something went wrong", message, onRetry, retryLabel = "Retry" }: ErrorBannerProps) {
  return (
    <div className="error-banner" role="alert">
      <div className="error-banner__body">
        <strong className="error-banner__title">{title}</strong>
        <span className="error-banner__message">{message}</span>
      </div>
      {onRetry ? (
        <button type="button" className="btn btn--secondary btn--sm" onClick={onRetry}>
          {retryLabel}
        </button>
      ) : null}
    </div>
  );
}
